import {
  Card, CardContent, Stack, Typography,
  Button as MuiButton,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useSelector } from '@client/hooks/redux.hooks';
import { getSessionUserState } from '@client/selectors/helpers/login';
import { openSignupModal } from '@client/components/Main/Signup';

const useStyles = makeStyles({ name: 'SignupCTA' })((theme) => ({
  card: {
    backgroundColor: theme.palette.warning.xlight,
    borderRadius: theme.radii.large,
  },
  cardContent: {
    padding: `${theme.spacing(3)} !important`,
  },
}));

export const SignupCTA = () => {
  const { classes } = useStyles();
  const userState = useSelector(getSessionUserState);

  if (userState) {
    return null;
  }

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Stack spacing={2}>
          <Typography
            variant="subtitle2"
            color="textSecondary"
          >
            Side Door connects artists and hosts, to create memorable shows in any space.
          </Typography>

          <Typography color="textSecondary">
            Interested in performing or hosting?
          </Typography>

          <div>
            <MuiButton
              id="sda-signup-cta-button"
              aria-label="sign up"
              onClick={openSignupModal as any}
              variant="contained"
              color="warning"
              className="main-signup-button"
            >
              Sign Up
            </MuiButton>
          </div>
        </Stack>
      </CardContent>
    </Card>
  );
};
